import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type {
  PageResponseDTO,
  PaginationParams,
} from "@/shared/types/pagination.types";
import type {
  ClientRequestDTO,
  ClientResponseDTO,
  ClientSearchParams,
} from "../types/client.types";

export const clientAdminService = {
  search: async (
    params?: ClientSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<ClientResponseDTO>> => {
    const response = await api.get<PageResponseDTO<ClientResponseDTO>>(
      API_ENDPOINTS.CLIENTS_ADMIN.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  create: async (
    data: ClientRequestDTO,
    options?: RequestOptions,
  ): Promise<ClientResponseDTO> => {
    const response = await api.post<ClientResponseDTO>(
      API_ENDPOINTS.CLIENTS_ADMIN.BASE,
      data,
      { signal: options?.signal },
    );
    return response.data;
  },

  list: async (
    params?: PaginationParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<ClientResponseDTO>> => {
    const response = await api.get<PageResponseDTO<ClientResponseDTO>>(
      API_ENDPOINTS.CLIENTS.PAGINATED,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<ClientResponseDTO> => {
    const response = await api.get<ClientResponseDTO>(
      API_ENDPOINTS.CLIENTS.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  update: async (
    id: number,
    data: ClientRequestDTO,
  ): Promise<ClientResponseDTO> => {
    const response = await api.put<ClientResponseDTO>(
      API_ENDPOINTS.CLIENTS.BY_ID(id),
      data,
    );
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.CLIENTS.BY_ID(id));
  },
};
